export const contentTableConfig = {
  title: '证书列表',
  propList: [
    {
      prop: 'name',
      label: '项目名称',
      minWidth: '80'
    },
    {
      prop: 'ip',
      label: '服务器IP',
      minWidth: '80'
    },
    {
      prop: 'certificate',
      label: '证书名称',
      minWidth: '80'
    },
    {
      prop: 'endTime',
      label: '到期时间',
      minWidth: '80'
    },
    {
      prop: 'aliAccount',
      label: '阿里云账号',
      minWidth: '80'
    },
    {
      label: '操作',
      minWidth: '80',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
